import { DayOfWeek, DayOfWeekLabel } from '../types/day-of-week.types';

export type RawSchedule = {
  id: number;
  locationId: number;
  startTime: string;
  endTime: string;
  dayOfWeek: DayOfWeek;
};

export type FormattedScheduleGroup = {
  dayLabelKeys: string[];
  intervals: string[];
};

const DAYS = [DayOfWeek.Sun, DayOfWeek.Mon, DayOfWeek.Tue, DayOfWeek.Wed, DayOfWeek.Thu, DayOfWeek.Fri, DayOfWeek.Sat];

export function buildScheduleDisplay(scheduleList: RawSchedule[], firstDayOfWeek: number): FormattedScheduleGroup[] {
  // Build a lookup: day -> ["09:00 - 18:00", ...]
  const byDay = Object.fromEntries(DAYS.map((d): [DayOfWeek, string[]] => [d, []])) as Record<DayOfWeek, string[]>;
  for (const { startTime, endTime, dayOfWeek } of scheduleList) {
    byDay[dayOfWeek].push(`${startTime.slice(0, 5)} - ${endTime.slice(0, 5)}`);
  }

  // Rotate days to start from firstDayOfWeek, then group consecutive days with same hours
  const ordered = [...DAYS.slice(firstDayOfWeek), ...DAYS.slice(0, firstDayOfWeek)];

  const groups: FormattedScheduleGroup[] = [];

  for (const day of ordered) {
    const intervals = byDay[day];
    const prev = groups.at(-1);

    if (prev && prev.intervals.join() === intervals.join()) {
      prev.dayLabelKeys[1] = DayOfWeekLabel[day];
    } else {
      groups.push({ dayLabelKeys: [DayOfWeekLabel[day]], intervals });
    }
  }

  return groups;
}
